import { ChangeDetectionStrategy, Component, HostBinding, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-item-divider',
  templateUrl: './item-divider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemDividerComponent {
  @Input()
  title: string;

  @Input()
  isHoverable: boolean;

  @Output()
  titleClicked = new EventEmitter<void>();

  @HostBinding('class')
  private readonly classes = 'flex items-center gap-x-2';

  get titleClasses(): string {
    const baseClasses = 'font-main text-sm font-bold text-navy-70 whitespace-nowrap';
    if (this.isHoverable) {
      return `${baseClasses} hover:text-blue-90 cursor-pointer`;
    }
    return baseClasses;
  }
}
